import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core'
import { FormControl, Validators } from '@angular/forms'
import { ToastrService } from 'ngx-toastr'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { ParametreDto } from '../../../data-access/http/dto/parametre-dto'
import { ParametreService } from '../../../data-access/http/parametre.service'
import { NotificationService } from '../../../data-access/http/notification.service'
import { SunleonService } from 'src/app/sunleon/data-access/http/sunleon.service'

@Component({
  selector: 'app-parametre-texte-modal',
  templateUrl: './parametre-texte-modal.component.html',
  styleUrls: ['./parametre-texte-modal.component.scss']
})
export class ParametreTexteModalComponent implements OnInit {

  @Input()
  parametre: ParametreDto
  overloadable: boolean
  control: FormControl
  formModalIsSubmitting: boolean = false
  controls: Record<string, FormControl>

  @ViewChild('inputValeur') inputValeur: ElementRef;
  @ViewChild('close') public modal: ParametreTexteModalComponent;

  constructor(
    private toastr: ToastrService,
    private parametreService: ParametreService,
    private sunLeonService: SunleonService,
    private activeModal: NgbActiveModal,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.control = new FormControl(this.parametre.valeur,[Validators.required]);
  }
  
  onSubmit(): void {
    if (this.control.valid) {
      this.formModalIsSubmitting = true
      const oldValue = this.parametre.valeur

      if (this.overloadable){
        this.sunLeonService.saveOverloadableParametres(this.parametre.code, this.control.value);
        this.activeModal.dismiss({valeur: this.control.value})

      } else {
        this.parametreService.saveParametreTypeSimple(this.parametre, this.control.value).subscribe({
          next:(data: any) => {
            const notif = this.notificationService.createNotification(this.parametre.id, this.parametre.code, this.parametre.type, oldValue, this.parametre.valeur)
            notif.subscribe({
              next: () => {},
              error: () => {
                this.toastr.error("Erreur lors de la création de la notification")
              },
            })
            this.toastr.success('Le paramètre ' + this.parametre.code + ' a été enregistré avec succès.')
            this.formModalIsSubmitting = false
            this.activeModal.dismiss(data)
          },
          error:() => {
            this.toastr.error('Erreur lors de l\'enregistrement du paramètre.')
            this.formModalIsSubmitting = false
            this.activeModal.dismiss()
          }}
        )
      }
    }
  }

  fermerModal(): void {
    this.activeModal.dismiss()
  }

}
